import http from '@/services/http.js';

const TEMPLATE_API = '/videoapi/template';
const TEMPLATE_LIST_API = '/videoapi/template/list';
const TEMPLATE_UPLOAD_API = '/videoapi/template/upload';
const TEMPLATE_SYNC_API = '/videoapi/template/sync';

export const fetchVideoTemplates = async () => {
  const response = await http.get(TEMPLATE_LIST_API);
  return response.data.data || [];
};

export const createVideoTemplate = async (payload) => {
  const response = await http.post(TEMPLATE_UPLOAD_API, payload);
  return response.data.data;
};

export const syncOrdinaryVideoTemplate = async (remoteTemplateId) => {
  const response = await http.post(TEMPLATE_SYNC_API, {
    remote_template_id: remoteTemplateId,
  });
  return response.data.data;
};

export const updateVideoTemplate = async (templateId, payload) => {
  const requestPayload = {
    ...payload,
    ...(Object.prototype.hasOwnProperty.call(payload, 'video_type_ids')
      ? { video_type_ids: payload.video_type_ids }
      : {}),
  };
  const response = await http.put(`${TEMPLATE_API}/${templateId}`, requestPayload);
  return response.data.data;
};

export const syncVideoTemplate = async (templateId) => {
  const response = await http.post(`${TEMPLATE_API}/${templateId}/sync`);
  return response.data.data;
};

export const parseVideoTemplateSlots = async (templateId) => {
  const response = await http.post(`${TEMPLATE_API}/${templateId}/parse-slots`);
  return response.data.data;
};

export const deleteVideoTemplate = async (templateId) => {
  const response = await http.delete(`${TEMPLATE_API}/${templateId}`);
  return response.data.data;
};
